import { Hidden } from '@ori-ui/mui';
import React from 'react';

import { updateImageUrl } from '../../utils';

interface Props {
  title: string;
  titleImage: string;
}

export const MobileAppIcon: React.FC<Props> = ({ title, titleImage }) => {
  if (titleImage === '') {
    return null;
  }

  const baseImage = (
    <img
      alt={title}
      loading="lazy"
      src={titleImage}
      width="35"
      height="35"
    />
  );

  const testUrl = titleImage.toLowerCase();
  if (testUrl.includes('inputformat=gif')) {
    return baseImage;
  }
  if (testUrl.includes('inputformat=svg')) {
    return baseImage;
  }

  const jpgSettings = ['h=120', 'q=90'];
  const onMdUp = ['ib=%23f5f5f5'];
  const mobileData = { url: titleImage, passPNG: false, jpgSettings };
  const desktopData = { url: titleImage, passPNG: false, jpgSettings: [...jpgSettings, ...onMdUp] };

  return (
    <>
      <Hidden mdUp>
        <img
          alt={title}
          loading="lazy"
          src={updateImageUrl(mobileData)}
          width="35"
          height="35"
        />
      </Hidden>
      <Hidden mdDown>
        <img
          alt={title}
          loading="lazy"
          src={updateImageUrl(desktopData)}
          width="35"
          height="35"
        />
      </Hidden>
    </>
  );
};
